var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElmartFeatureArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 399,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.416 184.343L371.582 320.51l194.276-194.276 78.058 78.058V.042h-204.25l78.057 78.057L371.582 224.24 235.416 88.073l-262.36 262.36 48.136 48.135 214.224-214.225z",
    fill: "#3B3B3B",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElmartFeatureArrow);
export default __webpack_public_path__ + "static/media/elmart-feature-arrow.9b38e21934474964c0587ec8ed3c30b4.svg";
export { ForwardRef as ReactComponent };